import { combineReducers } from "redux";
import { reducer as asyncReducer, REDUCER_NAME } from "async-action-creator";

import user from "./reducers/user";
import team from "./reducers/team";
import teams from "./reducers/teams";
import company from "./reducers/company";
import session from "./reducers/session";
import messages from "./reducers/messages";
import companies from "./reducers/companies";
import candidates from "./reducers/candidates";
import headquarter from "./reducers/headquarter";
import opportunity from "./reducers/opportunity";
import opportunities from "./reducers/opportunities";
import analytics from "./reducers/analytics";
import process from "./reducers/process";

const rootReducer = combineReducers({
  user,
  team,
  teams,
  company,
  session,
  messages,
  companies,
  candidates,
  headquarter,
  opportunity,
  opportunities,
  analytics,
  process,
  [REDUCER_NAME]: asyncReducer
});

export default rootReducer;
